import { Modal } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import LoadingContext from "../../../../ui/components/LoadingContext/LoadingContext";

import ArticleDistributionsTable from "./ArticleDistributionsTable";

export default function ArticleDistributionsModal({ article, onClose }) {
	const { t } = useTranslation();

	const [distributions, loading, error] = useCollectionData(
		db.collection("distributions").where("article.ref", "==", article.ref),
	);

	return (
		<Modal open size="large" onClose={onClose}>
			<Modal.Header>{t("distributionHistory", "Distribution history")}</Modal.Header>

			<LoadingContext data={distributions} loading={loading} error={error}>
				<Modal.Content>
					<ArticleDistributionsTable article={article} distributions={distributions} />
				</Modal.Content>
			</LoadingContext>
		</Modal>
	);
}
